// extracted by mini-css-extract-plugin
export default {"change-password-modal-container":"ChangePassword_change-password-modal-container__SiSss"};